<template lang="pug">
.iaq-container-parent
	a(
		data-iaq-container=''
		:class=`{
			'iaq-container-mini': size == 'mini',
			'iaq-container-small': size == 'small',
			'iaq-container-medium': size == 'medium',
			'iaq-container-large': size == 'large',
			'iaq-light': color == 'light',
			'iaq-light-2': color == 'light-2',
			'iaq-blue': color == 'blue',
			'iaq-dark': color == 'dark',
			'gradient': gradient,
			'iaq-measurement-icon': iconMode,
		}`
	)
		.iaq-indicator(v-if="!iconMode && size != 'medium' && size != 'large'")
			svg(viewBox='0 0 36 36' :width='svgSize + "px"' :height='svgSize + "px"' data-radial-graph='')
				defs
					filter#gaussianBlur(height='200%' x='-20%' y='-20%' width='200%')
						fegaussianblur(stdDeviation='2')
				path(d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831' fill='none' stroke-width='4' :stroke='radialColor' :style='"stroke-opacity:" + strokeOpacity' data-stroke='')
				path(d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831' fill='none' :stroke='gaussianColor' :style='"filter: url(#gaussianBlur);stroke-opacity:" + opacity' stroke-width='4' :stroke-dasharray='score + ",100"' stroke-linecap='round' data-stroke-dasharray='')
				path(d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831' fill='none' :stroke='radialColor' stroke-width='4' :stroke-dasharray='score + ",100"' stroke-linecap='round' data-stroke-dasharray='')
				text(:x='offset' y='23.5' font-size='14px' font-weight='300' :fill='textFill' data-text='') {{score}} 
				circle(cx="18" cy="18" r="18" fill="rgba(255,255,255,0.2)")
		.iaq-indicator.iaq-measurement-icon(v-else-if="iconMode")
			svg(xmlns='http://www.w3.org/2000/svg' width='36px' height='36px' viewBox='0 0 40 40' fill='none')
				path#Vector(fill='#4E7CFF' d='M24.7766 22.0233V7.10998C24.7766 5.84313 24.2734 4.62817 23.3776 3.73237C22.4818 2.83657 21.2668 2.33331 19.9999 2.33331C18.7331 2.33331 17.5181 2.83657 16.6223 3.73237C15.7265 4.62817 15.2233 5.84313 15.2233 7.10998V22.0233C13.7027 23.0467 12.551 24.5314 11.9378 26.2587C11.3247 27.986 11.2825 29.8646 11.8175 31.6177C12.3525 33.3708 13.4364 34.9057 14.9095 35.9963C16.3826 37.0869 18.167 37.6756 19.9999 37.6756C21.8328 37.6756 23.6173 37.0869 25.0904 35.9963C26.5635 34.9057 27.6474 33.3708 28.1824 31.6177C28.7174 29.8646 28.6752 27.986 28.0621 26.2587C27.4489 24.5314 26.2972 23.0467 24.7766 22.0233V22.0233ZM19.9999 35.6666C18.558 35.6671 17.1563 35.1917 16.0121 34.3142C14.8679 33.4368 14.0452 32.2063 13.6716 30.8136C13.2981 29.421 13.3945 27.9439 13.9459 26.6116C14.4974 25.2793 15.4731 24.1662 16.7216 23.445C16.8737 23.3572 17 23.2308 17.0878 23.0787C17.1756 22.9265 17.2217 22.754 17.2216 22.5783V7.10998C17.2225 6.37354 17.5155 5.66755 18.0364 5.14697C18.5573 4.62638 19.2635 4.33375 19.9999 4.33331C20.3626 4.33107 20.7222 4.40077 21.0577 4.53837C21.3933 4.67598 21.6983 4.87876 21.9549 5.13498C22.2158 5.39345 22.4227 5.7011 22.5637 6.04013C22.7048 6.37915 22.7771 6.74279 22.7766 7.10998V22.5783C22.7765 22.754 22.8227 22.9265 22.9104 23.0787C22.9982 23.2308 23.1245 23.3572 23.2766 23.445C24.525 24.1662 25.5006 25.2791 26.0521 26.6112C26.6036 27.9434 26.7002 29.4202 26.3268 30.8128C25.9534 32.2054 25.131 33.4359 23.9871 34.3135C22.8432 35.1911 21.4417 35.6667 19.9999 35.6666V35.6666ZM24.9999 29.1316C25.0001 30.0777 24.7318 31.0045 24.2262 31.8042C23.7206 32.6038 22.9985 33.2437 22.1438 33.6494C21.2891 34.055 20.3368 34.2099 19.3976 34.0959C18.4584 33.9819 17.5708 33.6038 16.8379 33.0055C16.105 32.4072 15.5569 31.6132 15.2573 30.7158C14.9577 29.8184 14.9188 28.8544 15.1452 27.9358C15.3716 27.0172 15.854 26.1816 16.5363 25.5263C17.2187 24.8709 18.073 24.4225 18.9999 24.2333V12.5C18.9999 12.2348 19.1053 11.9804 19.2928 11.7929C19.4804 11.6053 19.7347 11.5 19.9999 11.5C20.2652 11.5 20.5195 11.6053 20.7071 11.7929C20.8946 11.9804 20.9999 12.2348 20.9999 12.5V24.2333C22.129 24.4638 23.1438 25.0772 23.8727 25.9698C24.6016 26.8623 24.9998 27.9793 24.9999 29.1316V29.1316Z')
		.iaq-measurement-details
			.iaq-measurement-icon(v-if="size == 'medium' || size == 'large'") 
				svg(xmlns='http://www.w3.org/2000/svg' width='36px' height='36px' viewBox='0 0 40 40' fill='none')
					path#Vector(fill='#4E7CFF' d='M24.7766 22.0233V7.10998C24.7766 5.84313 24.2734 4.62817 23.3776 3.73237C22.4818 2.83657 21.2668 2.33331 19.9999 2.33331C18.7331 2.33331 17.5181 2.83657 16.6223 3.73237C15.7265 4.62817 15.2233 5.84313 15.2233 7.10998V22.0233C13.7027 23.0467 12.551 24.5314 11.9378 26.2587C11.3247 27.986 11.2825 29.8646 11.8175 31.6177C12.3525 33.3708 13.4364 34.9057 14.9095 35.9963C16.3826 37.0869 18.167 37.6756 19.9999 37.6756C21.8328 37.6756 23.6173 37.0869 25.0904 35.9963C26.5635 34.9057 27.6474 33.3708 28.1824 31.6177C28.7174 29.8646 28.6752 27.986 28.0621 26.2587C27.4489 24.5314 26.2972 23.0467 24.7766 22.0233V22.0233ZM19.9999 35.6666C18.558 35.6671 17.1563 35.1917 16.0121 34.3142C14.8679 33.4368 14.0452 32.2063 13.6716 30.8136C13.2981 29.421 13.3945 27.9439 13.9459 26.6116C14.4974 25.2793 15.4731 24.1662 16.7216 23.445C16.8737 23.3572 17 23.2308 17.0878 23.0787C17.1756 22.9265 17.2217 22.754 17.2216 22.5783V7.10998C17.2225 6.37354 17.5155 5.66755 18.0364 5.14697C18.5573 4.62638 19.2635 4.33375 19.9999 4.33331C20.3626 4.33107 20.7222 4.40077 21.0577 4.53837C21.3933 4.67598 21.6983 4.87876 21.9549 5.13498C22.2158 5.39345 22.4227 5.7011 22.5637 6.04013C22.7048 6.37915 22.7771 6.74279 22.7766 7.10998V22.5783C22.7765 22.754 22.8227 22.9265 22.9104 23.0787C22.9982 23.2308 23.1245 23.3572 23.2766 23.445C24.525 24.1662 25.5006 25.2791 26.0521 26.6112C26.6036 27.9434 26.7002 29.4202 26.3268 30.8128C25.9534 32.2054 25.131 33.4359 23.9871 34.3135C22.8432 35.1911 21.4417 35.6667 19.9999 35.6666V35.6666ZM24.9999 29.1316C25.0001 30.0777 24.7318 31.0045 24.2262 31.8042C23.7206 32.6038 22.9985 33.2437 22.1438 33.6494C21.2891 34.055 20.3368 34.2099 19.3976 34.0959C18.4584 33.9819 17.5708 33.6038 16.8379 33.0055C16.105 32.4072 15.5569 31.6132 15.2573 30.7158C14.9577 29.8184 14.9188 28.8544 15.1452 27.9358C15.3716 27.0172 15.854 26.1816 16.5363 25.5263C17.2187 24.8709 18.073 24.4225 18.9999 24.2333V12.5C18.9999 12.2348 19.1053 11.9804 19.2928 11.7929C19.4804 11.6053 19.7347 11.5 19.9999 11.5C20.2652 11.5 20.5195 11.6053 20.7071 11.7929C20.8946 11.9804 20.9999 12.2348 20.9999 12.5V24.2333C22.129 24.4638 23.1438 25.0772 23.8727 25.9698C24.6016 26.8623 24.9998 27.9793 24.9999 29.1316V29.1316Z')
			.iaq-measurement-values(v-if="size == 'medium' || size == 'large'")
				span(data-value='') {{score}} 
				span(data-unit='') {{unit}} 
			.iaq-measurement-name(v-if="size == 'medium' || size == 'large'") {{name}} 
			.iaq-measurement-name(v-if="iconMode") 
				span(data-name) {{curVal}} 
				span(data-unit) {{unit}} 
			.iaq-measurement-name.iaq-radial-mode(v-else-if="size == 'small' || size =='mini'") {{name}} 
			.iaq-measurement-indicator(v-if="size != 'large' && size != 'medium' && !iconMode" :class=`{
				'iaq-score-excellent': text == 'Excellent',
				'iaq-score-good': text == 'Good',
				'iaq-score-poor': text == 'Poor',
			}`) {{text}}
			.iaq-measurement-indicator(v-else-if="size != 'large' && iconMode") {{name}} 
		.iaq-logo-and-indicator(v-if="size != 'small' && size != 'mini'")
			.iaq-logo
				svg(width='26' height='28' viewBox='0 0 26 28' fill='none' xmlns='http://www.w3.org/2000/svg')
					path(fill-rule='evenodd' clip-rule='evenodd' d='M0 28L7.96584 5.37409H12.2163L9.87 12.0377H17.3081L21.546 0H25.7965L17.8306 22.6264H13.5802L16.1483 15.333H8.71018L4.25043 28H0Z')
			.iaq-score-indicator.iaq-measurement-indicator(v-if="size == 'large' || size == 'medium'" :class=`{
				'iaq-score-excellent': text == 'Excellent',
				'iaq-score-good': text == 'Good',
				'iaq-score-poor': text == 'Poor',
			}`) {{text}}  	
		.iaq-logo(v-else :class=`{'iaq-dark': (color == 'light' || color == "light-2"), 'iaq-light': (color == 'blue' || color == 'dark'), 'iaq-lower-logo': iconMode}`)
			.iaq-logo-measurement(v-if="!iconMode")
			.iaq-logo-measurement(v-else :class=`{
				'iaq-score-excellent': text == 'Excellent',
				'iaq-score-good': text == 'Good',
				'iaq-score-poor': text == 'Poor',
			}`) {{text}}
			svg(width='26' height='28' viewBox='0 0 26 28' fill='none' xmlns='http://www.w3.org/2000/svg' data-svg-icon)
				path(fill-rule='evenodd' clip-rule='evenodd' d='M0 28L7.96584 5.37409H12.2163L9.87 12.0377H17.3081L21.546 0H25.7965L17.8306 22.6264H13.5802L16.1483 15.333H8.71018L4.25043 28H0Z')
</template>
<script>
//import {HTTPClient} from '../assets/js/http';

//let client = new HTTPClient();
export default {
    name: 'Widget',
	
    components: {
        
    },
	props: {
		size: String,
		color: String,
		gradient: Boolean,
		iconMode: Boolean,
		measurement: Object,
	},
    data() {
		return {
			score: this.measurement? this.measurement.curScore : 92,
			unit: this.measurement? this.measurement.unit : '°F',
			curVal: this.measurement? this.measurement.curVal : '70',
			name: this.measurement? this.measurement.name : 'Space Temperature',
			gaussianColor: '',
			radialColor: '',
			text: '',
			class: '',
			opacity: '',
			strokeOpacity: '',
			textFill: '',
			svgSize: '',
			offset: 10,
		}
    },
	methods: {
		getIndicatorValues() {
			if(this.score >= 75) {
				return {
					text: "Excellent",
					class: "iaq-score-excellent",
					color: "#4E7CFF",
					score: this.score,
				}
			} else if(this.score>= 50 && this.score <75){
				return {
					text: "Good",
					class: "iaq-score-good",
					color: "#FFCA3A",
					score: this.score,
				}
			} else {
				return {
					text: "Poor",
					class: "iaq-score-poor",
					color: "#FF5050",
					score: this.score,
				}
			}
		}
	},
	mounted() {
		let res = this.getIndicatorValues();
		this.gaussianColor = res.color;
		this.radialColor = res.color;
		this.class = res.class;
		this.text = res.text;
		this.opacity = 0;
		this.strokeOpacity = 0.09;
		this.textFill = '#021449';
		this.svgSize = 72
	},
	watch: {
		'$props.color': {
			handler() {
				let res = this.getIndicatorValues();
				this.gaussianColor = res.color;
				this.radialColor = res.color;
				this.opacity = 0;
				this.textFill = '#021449';
				this.strokeOpacity = 0.09;
				
				if (this.color == 'blue') {
					this.gaussianColor = 'black';
					this.radialColor = 'white';
					this.opacity = .3;
					this.strokeOpacity = 0;
				}
				if (this.color == 'blue' || this.color == 'dark') {
					this.textFill = '#ffffff';
				}
				if (this.color == 'dark') {
					this.opacity = 1;
				}
			}
		},
		'$props.size': {
			handler() {
				this.svgSize = 72
				if (this.size == 'mini') {
					this.svgSize = 48 
				}
			}
		},
		'$props.measurement': {
			handler() {
				this.score = this.measurement? Math.round(this.measurement.curScore * 10) / 10 : 92;
				this.unit = this.measurement? this.measurement.unit : '°F';
				this.curVal = this.measurement? this.measurement.curVal : '70';
				this.name = this.measurement? this.measurement.name : 'Space Temperature';
				let res = this.getIndicatorValues();
				this.gaussianColor = res.color;
				this.radialColor = res.color;
				this.class = res.class;
				this.text = res.text;
				this.opacity = 0;
				this.strokeOpacity = 0.09;
				this.textFill = '#021449';
				this.svgSize = 72
				if (this.score.toString().length > 2) {
					this.offset = 6;
				} else {
					this.offset = 10;
				}
			},
		}
	}
}
</script>
<style lang="scss" scoped>
.iaq-container-parent {
    overflow: hidden;
    width: 50%;
    height: 100%;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    font-style: normal;
    display: flex;
	margin: auto;
    .iaq-score-excellent {
        color: #02C39A;
    }
    .iaq-score-good {
        color: #FFCA3A;
    }
    .iaq-score-poor {
        color: #FF5050;
    }
    .iaq-dark-text {
        color: #021449;
    }
    .iaq-light-text {
        color: #ffffff;
    }
    [data-radial-graph]{
        overflow: visible;
    }
.iaq-container-mini {
    width: 343px;
    height: 64px;
    box-sizing: border-box;
    border-radius: 100px;
    display: flex;
    cursor: pointer;
    text-decoration: none !important;
    &.iaq-light {
        background: #ffffff;
        border:  2px solid #f0f0f0;
        color: #021449;
        [data-unit] {
            color: rgba(2, 20, 73, 0.4)
        }
        &.gradient {
            background: linear-gradient(123.1deg, #FFFFFF 24.7%, #D4D4D4 151.23%, #D4D4D4 151.23%);
        }
    }
    &.iaq-light-2 {
        background: #ffffff;
        border: 2px solid #021449;
        color: #021449;
        [data-unit] {
            color: rgba(2, 20, 73, 0.4)
        }
        &.gradient {
            background: linear-gradient(123.1deg, #FFFFFF 24.7%, #D4D4D4 151.23%, #D4D4D4 151.23%);
        }
    }
    &.iaq-blue {
        background: #3456F7;
        color: #ffffff;
        [data-unit] {
            color:  rgba(255, 255, 255, 0.4);
        }
        &.gradient {
            background: linear-gradient(125.06deg, #3456F7 26.15%, #00188A 141.6%);
        }
        .iaq-indicator {
            &.iaq-measurement-icon {
                svg {
                    height: 48px;
                    width: 48px;
                }
                path {
                    fill: #ffffff;
                }
            }
          
        }
    }
    &.iaq-dark {
        background: #25294A;
        color: #ffffff;
        [data-unit] {
            color: rgba(255, 255, 255, 0.4);
        }
        &.gradient {
            background: linear-gradient(136.04deg, #25294A 11.89%, #020308 149.83%);
        }
        .iaq-indicator {
            &.iaq-measurement-icon {
                path {
                    fill: #ffffff;
                }
            }
          
        }
    }
    .iaq-indicator {
        width: 20%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: visible;
    }
    .iaq-measurement-details {
        width: 55%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .iaq-measurement-name {
            line-height: 28px;
            font-size: 18px;
            // font-weight: 400;
            [data-unit] {
                font-size: 12px;
            }
        }
        .iaq-measurement-indicator {
            line-height:20px;
            font-size: 14px;
        }
    }
    .iaq-logo {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        flex-direction: column;
        height: 100%;
        width: 25%;
        > * {
            margin-right: 19.2px;
        }
        .iaq-logo-measurement {
            font-size: 14px;
            line-height: 20px;
        }
        &.iaq-light {
            path {
                fill: #FFFFFF;
            }
            
        }
        &.iaq-dark {
            path {
                fill: #1D213C;
            }
        }
    }
}
.iaq-container-small {
    width: 364px;
    height: 96px;
    box-sizing: border-box;
    border-radius: 100px;
    display: flex;
    cursor: pointer;
    text-decoration: none !important;
    &.iaq-light {
        background: #ffffff;
        border:  2px solid #f0f0f0;
        color: #021449;
        [data-unit] {
            color: rgba(2, 20, 73, 0.4)
        }
        &.gradient {
            background: linear-gradient(123.1deg, #FFFFFF 24.7%, #D4D4D4 151.23%, #D4D4D4 151.23%);
        }
    }
    &.iaq-light-2 {
        background: #ffffff;
        border: 2px solid #021449;
        color: #021449;
        [data-unit] {
            color: rgba(2, 20, 73, 0.4)
        }
        &.gradient {
            background: linear-gradient(123.1deg, #FFFFFF 24.7%, #D4D4D4 151.23%, #D4D4D4 151.23%);
        }
    }
    &.iaq-blue {
        background: #3456F7;
        color: #ffffff;
        [data-unit] {
            color:  rgba(255, 255, 255, 0.4);
        }
        &.gradient {
            background: linear-gradient(125.06deg, #3456F7 26.15%, #00188A 141.6%);
        }
        .iaq-indicator {
            &.iaq-measurement-icon {
                svg {
                    height: 48px;
                    width: 48px;
                }
                path {
                    fill: #ffffff;
                }
            }
        
        }
    }
    &.iaq-dark {
        background: #25294A;
        color: #ffffff;
        [data-unit] {
            color: rgba(255, 255, 255, 0.4);
        }
        &.gradient {
            background: linear-gradient(136.04deg, #25294A 11.89%, #020308 149.83%);
        }
        .iaq-indicator {
            &.iaq-measurement-icon {
                path {
                    fill: #ffffff;
                }
            }
          
        }
    }
    .iaq-indicator {
        width: 25%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: visible;
    }
    .iaq-measurement-details {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        > * {
            margin-left: 5px;
        }
        .iaq-measurement-name {
            line-height: 32px;
            font-size: 24px;
            [data-unit] {
                font-size: 12px;
            }
            &.iaq-radial-mode {
                font-size: 20px;
            }
        }
        .iaq-measurement-indicator {
            line-height: 30px;
            font-size: 16px;
        }
    }
    .iaq-logo {
        // display: flex;
        // align-items: flex-end;
        // justify-content: center;
        // flex-direction: column;
        position: relative;
        height: 100%;
        width: 25%;
         > * {
            position: absolute;
            right: 35px;
        }
        .iaq-logo-measurement {
            font-size: 16px;
            line-height: 30px;
            top: 13px
        }
        svg {
            bottom: 34px;
        }
        &.iaq-light {
            path {
                fill: #FFFFFF;
            }
            
        }
        &.iaq-dark {
            path {
                fill: #1D213C;
            }
        }
        &.iaq-lower-logo {
            [data-svg-icon]{
                bottom: 24px;
            }
        }
    }
}
.iaq-container-medium {
    width: 316px;
    height: 214px;
    box-sizing: content-box;
    display: flex;
    cursor: pointer;
    position: relative;
    border-radius: 20px;
    text-decoration: none !important;
    svg {
        display: block
    }
    &.iaq-light {
        background: #ffffff;
        border:  2px solid #f0f0f0;
        color: #021449;
        &.gradient {
            background: linear-gradient(123.1deg, #FFFFFF 24.7%, #D4D4D4 151.23%, #D4D4D4 151.23%);
        }
        [data-unit] {
            color: rgba(2, 20, 73, 0.4)
        }
        .iaq-logo {
            path {
                fill: #1D213C;
            }
        }
    }
    &.iaq-light-2 {
        background: #ffffff;
        border: 2px solid #021449;
        color: #021449;
        &.gradient {
            background: linear-gradient(123.1deg, #FFFFFF 24.7%, #D4D4D4 151.23%, #D4D4D4 151.23%);
        }
        [data-unit] {
            color: rgba(2, 20, 73, 0.4)
        }
        .iaq-logo {
            path {
                fill: #1D213C;
            }
        }
        
    }
    &.iaq-blue {
        background: #3456F7;
        color: #ffffff;
        border: 2px solid transparent;
        &.gradient {
            background: linear-gradient(125.06deg, #3456F7 26.15%, #00188A 141.6%);
        }
        [data-unit] {
            color:  rgba(255, 255, 255, 0.4);
        }
        .iaq-measurement-icon {
            path {
                fill: #FFFFFF;
            }
        }
        .iaq-logo {
            path {
                fill: #FFFFFF;
            }
        }
    }
    &.iaq-dark {
        background: #25294A;
        color: #ffffff;
        border: 2px solid transparent;
        [data-unit] {
            color: rgba(255, 255, 255, 0.4);
        }
        &.gradient {
            background: linear-gradient(136.04deg, #25294A 11.89%, #020308 149.83%);
        }
        .iaq-logo {
            path {
                fill: #FFFFFF;
            }
        }
        
    }
    .iaq-measurement-details {
        height: 100%;
        width: 80%;
        position: relative;
        display: flex;
        flex-direction: column;;
        > * {
            margin-left: 32px;
        }
        .iaq-measurement-icon {
            margin-top: 34.3px;
            margin-bottom: 18.32px
        } 
        .iaq-measurement-values {
            font-size: 48px;
            margin-bottom: 6px;
            font-weight: 300;
            [data-unit] {
                font-size: 18px;
                font-weight: 400;
            }
        }
        .iaq-measurement-name {
            font-size: 24px;
        }
    }
    .iaq-logo-and-indicator {
        height: 100%;
        width: 20%;
        position: relative;
        > * {
            position: absolute;
            right: 24px;
        }
        .iaq-logo {
            bottom: 33px;
        }
        .iaq-score-indicator {
            top: 24px;
            line-height: 30px;
            font-size: 18px;
        }
    }
}
.iaq-container-large {
    width: 343px;
    height: 132px;
    box-sizing: content-box;
    display: flex;
    cursor: pointer;
    position: relative;
    border-radius: 20px;
    text-decoration: none !important;
    svg {
        display: block
    }
    &.iaq-light {
        background: #ffffff;
        border:  2px solid #f0f0f0;
        color: #021449;
        &.gradient {
            background: linear-gradient(123.1deg, #FFFFFF 24.7%, #D4D4D4 151.23%, #D4D4D4 151.23%);
        }
        [data-unit] {
            color: rgba(2, 20, 73, 0.4)
        }
        .iaq-logo {
            path {
                fill: #1D213C;
            }
        }
    }
    &.iaq-light-2 {
        background: #ffffff;
        border: 2px solid #021449;
        color: #021449;
        &.gradient {
            background: linear-gradient(123.1deg, #FFFFFF 24.7%, #D4D4D4 151.23%, #D4D4D4 151.23%);
        }
        [data-unit] {
            color: rgba(2, 20, 73, 0.4)
        }
        .iaq-logo {
            path {
                fill: #1D213C;
            }
        }
        
    }
    &.iaq-blue {
        background: #3456F7;
        color: #ffffff;
        border: 2px solid transparent;
        &.gradient {
            background: linear-gradient(125.06deg, #3456F7 26.15%, #00188A 141.6%);
        }
        [data-unit] {
            color:  rgba(255, 255, 255, 0.4);
        }
        .iaq-measurement-icon {
            path {
                fill: #FFFFFF;
            }
        }
        .iaq-logo {
            path {
                fill: #FFFFFF;
            }
        }
    }
    &.iaq-dark {
        background: #25294A;
        color: #ffffff;
        border: 2px solid transparent;
        [data-unit] {
            color: rgba(255, 255, 255, 0.4);
        }
        &.gradient {
            background: linear-gradient(136.04deg, #25294A 11.89%, #020308 149.83%);
        }
        .iaq-logo {
            path {
                fill: #FFFFFF;
            }
        }
        
    }
    .iaq-measurement-details {
        height: 100%;
        width: 80%;
        position: relative;
        display: flex;
        flex-direction: column;;
        > * {
            margin-left: 16px;
        }
        .iaq-measurement-icon {
            margin-top: 17px;
            margin-bottom: 18px
        } 
        .iaq-measurement-values {
            font-size: 24px;
            [data-unit] {
                font-size: 18px;
            }
        }
        .iaq-measurement-name {
            font-size: 16px;
            line-height: 32px;
        }
    }
    .iaq-logo-and-indicator {
        height: 100%;
        width: 20%;
        position: relative;
        > * {
            position: absolute;
            right: 16px;
        }
        .iaq-logo {
            bottom: 16px;
        }
        .iaq-score-indicator {
            top: 16px;
            line-height: 30px;
            font-size: 16px;
        }
    }
}
}

</style>